// Geographical center of the contiguous United States
export const DEFAULT_LATITUDE = '39.8282'
export const DEFAULT_LONGITUDE = '-98.5796'

export const DEFAULT_FLY_TO_ZOOM = 16
export const DEFAULT_INITIAL_ZOOM = 2

export const OVERRIDE_MARKER_COLOR = 'black'
